import { observer } from "mobx-react";
import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { SearchAction } from "@state/stores/offer/search/SearchStore";

export const SuggestedListFreeSearchItem = observer(
	function HeaderFreeSearchListItem() {
		const store = useRootAppStore().searchStore;
		const t = useTranslation().t;
		const form = useFormContext();

		let error = form?.formState?.errors?.search;

		if (
			store.searchTerm.length < store.minLengthForFreeSearchSubmit ||
			error
		) {
			return null;
		}

		return (
			<li
				className="popup--search__term"
				onClick={(event) => {
					event.preventDefault();
					event.stopPropagation();

					const searchResult = store.searchSuggestedItem(
						SearchAction.PICK_FIRST,
						{
							displayText: store.searchTerm,
						}
					);

					if (searchResult) {
						form.reset();
					}

					store.setIsSuggestedListOpen(false);
				}}
			>
				<span className="popup--search__name">
					{t("SEARCH.SHOW_ALL_SEARCH_TERM")} "{store.searchTerm}"
					<i className="u-icon u-icon--tny u-icon--arrow-right u-mar--left--tny" />
				</span>
			</li>
		);
	}
);
